import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "~common/service/authentication.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { MsalService, MsalBroadcastService } from "@azure/msal-angular";
import {
  AuthenticationResult,
  AccountInfo,
  EventMessage,
  EventType,
} from "@azure/msal-browser";
import { filter, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "app-sso",
  templateUrl: "./sso.component.html",
  styleUrls: ["./sso.component.scss"],
})
export class SsoComponent implements OnInit {
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private message: NzMessageService,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}

  ngOnInit(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        console.log("Login Finished !!");

        // Casting payload as AuthenticationResult to access account
        const payload = result.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(payload.account);

        // Get jwt token from login api
        this.callAuthAPI(payload.accessToken);
      });

    var accountInfo: AccountInfo = this.msalService.instance.getActiveAccount();
    if (accountInfo) {
      this.callAuthAPI(accountInfo.username);
    } else {
      this.tryToLogIn();
    }
  }

  tryToLogIn() {
    console.log("logging in...");
    this.msalService.loginRedirect();
  }

  callAuthAPI(accessToken: string) {
    const loginReq = {
      email: accessToken,
    };

    this.authService
      .login(loginReq)
      .then((result) => {
        if (result && result.isSuccess) {
          this.authService.saveMicrosoftToken(accessToken);
          this.authService.saveToken(result.payload.token);
          this.authService.me().then((result) => {
            this.authService.saveProfile(result.payload);
            if (result.payload.isAdmin) {
              this.router.navigate(["/admin"]);
            } else {
              this.router.navigate(["/"]);
            }
          });
        } else {
          this.message.create("error", result.message);
        }
      })
      .catch((err) => {
        console.log("Error:", err);
        this.message.create("error", err.message);
      });
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
